import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { LogoManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/logo")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <LogoManagement />
    </RouteGuard>
  ),
});
